module.exports = __webpack_public_path__ + "bd3c97e951ccb790342db4cab78a2824.jpg";